import React from "react";
import {Route, Routes} from "react-router";

// layout
import Feelsy from "@/pages/feelsy";

function Main() {

    return (
        <Routes>
            <Route index path={"/"} element={<Feelsy />} />
        </Routes>
    );
}

export default Main;
